var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SET_MODAL, REMOVE_MODAL, REMOVE_ALL_MODALS } from './actions';
export var initialState = {
    modals: [],
};
export var notificationsModuleReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case SET_MODAL:
            return __assign(__assign({}, state), { modals: __spreadArray([payload], state.modals, true) });
        case REMOVE_MODAL:
            return __assign(__assign({}, state), { modals: state.modals.filter(function (modal) { return modal.id !== payload; }) });
        case REMOVE_ALL_MODALS:
            return __assign(__assign({}, state), { modals: state.modals.map(function (modal) { return (__assign(__assign({}, modal), { isClosing: true })); }) });
        default:
            return state;
    }
};
